interface FilterItem {
  field?: string;
  operator?: string;
  value?: unknown;
}

const RANGE_SUFFIX: Record<string, string> = {
  onOrAfter: '_gte',
  after: '_gt',
  onOrBefore: '_lte',
  before: '_lt',
};

const PASSTHROUGH_OPERATORS = new Set(['contains', 'equals', 'is', '=']);
const JOIN_OPERATORS = new Set(['isAnyOf']);

/**
 * Builds backend query params from a MUI DataGrid `filterModel.items` array.
 *
 * Operators without a corresponding backend convention (startsWith, endsWith,
 * not, isEmpty, isNotEmpty) are dropped rather than degraded to an exact-match
 * param - sending `field=value` for e.g. "does not contain" would silently
 * return wrong results, which is worse than the filter doing nothing.
 */
export function buildFilterParams(items: FilterItem[] | undefined): Record<string, string> {
  const params: Record<string, string> = {};
  (items || []).forEach((it) => {
    if (!it || !it.field || it.value == null || it.value === '') return;
    const field = it.field;
    const op = it.operator;

    if (op && JOIN_OPERATORS.has(op)) {
      const arr = Array.isArray(it.value) ? it.value : [it.value];
      params[field] = arr.map(String).join(',');
    } else if (op && op in RANGE_SUFFIX) {
      params[`${field}${RANGE_SUFFIX[op]}`] = String(it.value);
    } else if (op && PASSTHROUGH_OPERATORS.has(op)) {
      params[field] = String(it.value);
    }
  });
  return params;
}
